import { render, staticRenderFns } from "./IndividualLoyaltyCard.vue?vue&type=template&id=0191b47e&"
import script from "./IndividualLoyaltyCard.vue?vue&type=script&lang=js&"
export * from "./IndividualLoyaltyCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports